import React, { PropsWithChildren } from 'react';
import {
    Dialog,
    DialogPanel,
    Transition,
    TransitionChild,
} from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';

const FullScreenModal = ({
    isOpen,
    onClose,
    widthClass,
    children,
    hideClose,
    backgroundClassName,
    panelClassName,
    panelContainerClassName,
    modalClassName,
    alignTop,
}) => {
    if (!hideClose && !onClose) {
        hideClose = true;
    }

    return (
        <Transition show={isOpen} appear>
            <Dialog
                className={`relative z-50 modal ${modalClassName || ''}`}
                onClose={onClose ? onClose : () => {}}
            >
                <TransitionChild
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div
                        className={`fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity ${backgroundClassName}`}
                    />
                </TransitionChild>

                <div className="fixed inset-0 z-50 w-screen overflow-y-auto">
                    <div
                        className={`flex min-h-full ${!!alignTop ? 'items-start' : 'items-end sm:items-center'} justify-center text-center sm:p-0 ${panelContainerClassName}`}
                    >
                        <TransitionChild
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                            <DialogPanel
                                className={`modal-panel-white bg-white w-screen h-screen overflow-scroll relative transform p-6 text-left transition-all sm:p-6 ${panelClassName}`}
                            >
                                {!hideClose && (
                                    <button
                                        className="btn-gray-link absolute right-5 top-5"
                                        onClick={onClose}
                                    >
                                        <XMarkIcon className="w-5 h-5" />
                                    </button>
                                )}

                                {children}
                            </DialogPanel>
                        </TransitionChild>
                    </div>
                </div>
            </Dialog>
        </Transition>
    );
};

export default FullScreenModal;
